import { Storage } from '../interfaces/storage.interface';

export class LocalStorage implements Storage {

  getItem(key: string): any {
    return localStorage.getItem(key);
  }
  setItem(key: string, value: any): void {
    localStorage.setItem(key, value);
  }
  removeItem(key: string): void {
    localStorage.removeItem(key);
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/(IGH Projects)/jobs/EVFS PROD_FRONTEND granima.de/workspace/frontend/src/app/models/local-storage.model.ts